
import React from "react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProfileTypeFieldProps {
  value: string;
  onValueChange: (name: string, value: string) => void;
  error?: string;
}

export const ProfileTypeField: React.FC<ProfileTypeFieldProps> = ({
  value,
  onValueChange,
  error
}) => {
  return (
    <div>
      <label htmlFor="profileType" className="block mb-2 font-medium text-gray-700">
        Vous êtes*
      </label>
      <Select 
        onValueChange={(value) => onValueChange("profileType", value)} 
        value={value}
      >
        <SelectTrigger className={`w-full ${error ? 'border-red-500' : ''}`}>
          <SelectValue placeholder="Sélectionnez votre profil" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="professional">Un professionnel</SelectItem>
          <SelectItem value="community">Une collectivité</SelectItem>
          <SelectItem value="individual">Un particulier</SelectItem>
          <SelectItem value="other">Autre</SelectItem>
        </SelectContent>
      </Select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};
